"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekChart = void 0;
var react_1 = __importStar(require("react"));
var week_chart_model_1 = require("./week-chart-model");
var Normalizer_1 = require("../Normalizer");
var react_dom_1 = require("react-dom");
var DonutChart_1 = require("../DonutChart");
function WeekHeader() {
    return react_1.default.createElement("div", { className: "d-flex week-header" }, week_chart_model_1.Days.map(function (i) { return react_1.default.createElement("div", { className: "day-label" }, (0, week_chart_model_1.dayShortLabel)(i)); }));
}
function pad(n) {
    if (n < 10)
        return "0" + n;
    return n;
}
function formatHour(hour) {
    return "".concat(pad(hour), ":00");
}
var weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
function HourRow(_a) {
    var hour = _a.hour, items = _a.items, normalizer = _a.normalizer;
    var time = (0, react_1.useMemo)(function () {
        var t = parseInt(hour);
        return formatHour(t);
    }, [hour]);
    return react_1.default.createElement("div", { className: "d-flex hour-row" },
        react_1.default.createElement("div", null, time),
        weekdays.map(function (w) {
            var a = items.find(function (i) { return i.day == w; });
            return react_1.default.createElement("div", { key: w, className: "bg-primary", "data-value": a && JSON.stringify(a), style: { '--bs-bg-opacity': (a === null || a === void 0 ? void 0 : a.value) ? 0.3 + normalizer.normalize(a.value) : 0.15 } });
        }));
}
function WeekChart(_a) {
    var data = _a.data;
    var ref = (0, react_1.useRef)();
    var info = (0, react_1.useMemo)(function () {
        var list = (0, week_chart_model_1.streamToObject)(data);
        var byHour = (0, week_chart_model_1.groupBy)(list, "hour");
        var byDay = (0, week_chart_model_1.groupBy)(list, "hour");
        var normalizer = new Normalizer_1.Normalizer('value', 0.7);
        normalizer.updateData(list);
        return { byDay: byDay, byHour: byHour, normalizer: normalizer };
    }, [data]);
    var _b = (0, react_1.useState)(null), item = _b[0], setItem = _b[1];
    var _c = (0, react_1.useState)(null), tooltipContent = _c[0], setTooltipContent = _c[1];
    var _d = (0, react_1.useState)(null), tooltipPoint = _d[0], setTooltipPoint = _d[1];
    function onMouseMove(e) {
        var element = e.target;
        if ('dataset' in element && element.dataset.value !== undefined) {
            var rect = e.target.getBoundingClientRect();
            //setTooltipPoint({x: e.clientX, y: e.clientY + 20})
            setTooltipPoint({ x: rect.left + rect.width * .5, y: rect.top + 28 });
            setItem(element.dataset.value);
            return;
        }
        //setItem(null);
    }
    (0, react_1.useEffect)(function () {
        if (item === null) {
            setTooltipContent(null);
            return;
        }
        var n = JSON.parse(item);
        setTooltipContent(react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("b", null, n.value),
            " Leads ",
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", { className: "badge bg-primary" },
                (0, week_chart_model_1.dayLabel)(n.day),
                " - ",
                formatHour(n.hour))));
        ref.current.focus();
    }, [item]);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { ref: ref, className: "time-chart", onMouseMove: onMouseMove, tabIndex: -1, onBlur: function () { return setItem(null); } },
            react_1.default.createElement(WeekHeader, null),
            Object.entries(info.byHour).map(function (_a) {
                var hour = _a[0], items = _a[1];
                return react_1.default.createElement(HourRow, { key: hour, hour: hour, items: items, normalizer: info.normalizer });
            })),
        (0, react_dom_1.createPortal)(react_1.default.createElement(DonutChart_1.DonutTooltip, { strategy: 'absolute', key: "tooltip", content: tooltipContent, x: tooltipPoint === null || tooltipPoint === void 0 ? void 0 : tooltipPoint.x, y: tooltipPoint === null || tooltipPoint === void 0 ? void 0 : tooltipPoint.y }), document.body));
}
exports.WeekChart = WeekChart;
//# sourceMappingURL=week-chart.js.map